(function () {
  const MARK_HASH = '#open-form';
  const MARK_QUERY_KEY = 'open_form';
  const MARK_QUERY_VAL = '1';

  function shouldOpenFromUrl(url) {
    const hash = (url.hash || '').toLowerCase();
    const openHash = hash === MARK_HASH;
    const openQuery =
      url.searchParams && url.searchParams.get(MARK_QUERY_KEY) === MARK_QUERY_VAL;
    return openHash || openQuery;
  }

  function cleanUrlMarker() {
    const u = new URL(window.location.href);
    u.hash = '';
    u.searchParams.delete(MARK_QUERY_KEY);
    window.history.replaceState({}, '', u.toString());
  }

  // ✅ Shopify Forms lives in <shopify-forms-embed> shadow DOM
  function findFormsTeaserButton() {
    const embeds = document.querySelectorAll('shopify-forms-embed');
    for (const embed of embeds) {
      const sr = embed.shadowRoot;
      if (!sr) continue;

      // Your screenshot shows this exact button
      const btn = sr.querySelector('button[aria-haspopup="dialog"]');
      if (btn) return btn;

      // Fallback: find the internal container, then button
      const app = sr.querySelector('#app-embed');
      if (app) {
        const btn2 = app.querySelector('button[aria-haspopup="dialog"]');
        if (btn2) return btn2;
      }
    }
    return null;
  }

  function openShopifyFormsPopup() {
    const btn = findFormsTeaserButton();
    if (!btn) return false;
    btn.click();
    return true;
  }

  function waitForFormsThenOpen(timeoutMs = 4000) {
    if (openShopifyFormsPopup()) return Promise.resolve(true);

    return new Promise((resolve) => {
      const start = Date.now();
      const obs = new MutationObserver(() => {
        if (openShopifyFormsPopup()) {
          obs.disconnect();
          resolve(true);
        } else if (Date.now() - start > timeoutMs) {
          obs.disconnect();
          resolve(false);
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });

      setTimeout(() => {
        obs.disconnect();
        resolve(openShopifyFormsPopup());
      }, timeoutMs);
    });
  }

  // Click behavior:
  // - If link is same page: prevent navigation, open immediately
  // - If link goes to a different page: allow navigation, then auto-open on load
  document.addEventListener(
    'click',
    async (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;

      let url;
      try {
        url = new URL(a.getAttribute('href'), window.location.origin);
      } catch {
        return;
      }

      if (!shouldOpenFromUrl(url)) return;

      const isSamePage =
        url.origin === window.location.origin &&
        url.pathname === window.location.pathname;

      if (isSamePage) {
        e.preventDefault();
        e.stopPropagation();

        const ok = await waitForFormsThenOpen();
        if (!ok) console.warn('Shopify Forms teaser button not found.');
        cleanUrlMarker();
      }
      // else: different page → let it navigate; load handler below will open
    },
    true
  );

  // Auto-open on landing
  window.addEventListener('load', async () => {
    const url = new URL(window.location.href);
    if (!shouldOpenFromUrl(url)) return;

    const ok = await waitForFormsThenOpen();
    if (ok) cleanUrlMarker();
  });
})();
